import { IBarcodeStyle } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification, IBarcodeInformationSpecification, IBarcodeCscanSetSpecification } from "../IFormatSpecification";
import { IBarcodeObject, IBarcodeItem } from "../objects";
import { AbstractTextPresentableObjectEditor } from "./AbstractTextPresentableObjectEditor";

export class BarcodeObjectEditor extends AbstractTextPresentableObjectEditor<IBarcodeObject> {
  constructor(source: IBarcodeObject | BarcodeObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._name = this.createNamePropertyEditor();
    // TODO: CScan項目から名称選択して反映するUI用の情報が必要.(nameをやめて別実装？nameに追加して実装？)
    this._nameHistories = this.createNameHistoriesPropertyEditor();
    this._bookmark = this.createBookmarkPropertyEditor();
    this._barcodeStyle = this.createPropertyEditor(s => s.barcodeStyle, (s, v) => s.barcodeStyle = v);
    this._barcodeItems = this.createPropertyEditor(s => s.items, (s, v) => s.items = v);
  }

  protected _barcodeStyle: IPropertyEditable<IBarcodeStyle>;
  protected _barcodeItems: IPropertyEditable<IBarcodeItem[]>;

  barcodeStyle(): IPropertyEditable<IBarcodeStyle> {
    return this._barcodeStyle;
  }

  barcodeItems(): IPropertyEditable<IBarcodeItem[]> {
    return this._barcodeItems;
  }

  getSelectableBarcodeInformations(): IBarcodeInformationSpecification[] {
    return this._specification.objects.barcode.barcodeInformations;
  }

  getSelectableCscanSets(): IBarcodeCscanSetSpecification[] {
    return this._specification.objects.barcode.cscanSets;
  }

  getTypeName(): string {
    return "バーコード";
  }

  clone(): IFormatObjectEditable {
    return new BarcodeObjectEditor(this);
  }
}
